import React, { useState, useEffect } from 'react';
import 'leaflet/dist/leaflet.css';
import './PopupCT.css';
import { useTranslation } from 'react-i18next';

const PopupCT = (props) => {

    const { t } = useTranslation();
    const { id, nombre, estado, color } = props;
    var link = "/#/ct/" + id;

    //Deshabilitar el link si no hay pantalla de ct
    const screen = JSON.parse(sessionStorage.getItem('ScreenConfiguration')).filter(screen => screen.Screen === "CT");
    const [hrefDisabled, setHrefDisabled] = useState(<></>);

    useEffect(() => {
        if (screen[0].Enabled === false) {
            setHrefDisabled(<a className='a-ct' style={{ cursor: 'none' }}>{nombre}</a>)
        } else {
            setHrefDisabled(<a className='a-ct' href={link}>{nombre}</a>)
        }
    }, []);

    return (
        <div className='container-fluid' style={{ width: 'max-content', padding: '0px' }}>
            <div className='row justify-content-center' style={{ margin: '15px' }}>
                <div className='col-auto'>
                    {hrefDisabled}
                </div>
            </div>
            <div className='row' style={{ margin: '5px' }}>
                <div className='col-auto'>{t('scada.map.popupCT.status')} <strong style={{ color: color }}>{estado}</strong>
                </div>
            </div>
        </div>
    );
};

export default PopupCT;